import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
/*
 * Common format to use for date comparisons and state
 */
export const DATE_FORMAT = 'YYYY-MM-DD';
export const UI_MONTH_FORMAT = 'MMM YYYY';
export const UI_DAY_FORMAT = 'MMMM D';
export const TIME_ZONE_NAME = 'America/New_York';
dayjs.extend(utc);
dayjs.extend(timezone);
export const getWeekdays = (format) => {
    const weekdays = [];
    format = format || 'ddd';
    for (let i = 0; i < 7; i++) {
        weekdays.push(dayjs().day(i).format(format));
    }
    return weekdays;
};
/*
 * Append dates to the beginning and end of the day array as needed to fill up the grid
 */
export const fillWeeksForGrid = (dayArray, includeTrailing = false) => {
    const firstDayData = dayjs(dayArray[0].date);
    const lastDayData = firstDayData.endOf('month');
    let leadingDays = [];
    let trailingDays = [];
    // If first day of the month isn't Sunday (dependent on locale)
    if (firstDayData.day() !== 0) {
        // backtrack through dates until you reach Sunday
        let offset = 1;
        for (let i = firstDayData.day() - 1; i > -1; i--) {
            leadingDays.unshift({ date: firstDayData.subtract(offset, 'day').format(DATE_FORMAT), events: [] });
            offset += 1;
        }
    }
    if (includeTrailing) {
        // Opposite process from first day
        if (lastDayData.day() !== 6) {
            let offset = 1;
            for (let i = lastDayData.day() + 1; i < 7; i++) {
                trailingDays.push({ date: lastDayData.add(offset, 'day').format(DATE_FORMAT), events: [] });
                offset += 1;
            }
        }
    }
    return includeTrailing ? [...leadingDays, ...dayArray, ...trailingDays] : [...leadingDays, ...dayArray];
};
export const getMonthsInRange = (startDate, endDate) => {
    let months = [];
    let start = dayjs(startDate).startOf('month');
    let end = dayjs(endDate).endOf('month');
    for (let i = start; i.isBefore(end); i = i.add(1, 'month')) {
        months.push({ month: i.format(DATE_FORMAT), days: [] });
    }
    return months;
};
export const getDaysInMonth = (monthDate) => {
    let days = [];
    let start = dayjs(monthDate).startOf('month').startOf('day');
    let end = dayjs(monthDate).endOf('month').endOf('day');
    for (let i = start; i.isBefore(end); i = i.add(1, 'day')) {
        days.push({ date: i.format(DATE_FORMAT), events: [] });
    }
    return days;
};
export const sortEventsChronologically = (events) => {
    const sorted = events.sort((a, b) => {
        return dayjs(a.eventDate).tz(TIME_ZONE_NAME).isBefore(dayjs(b.eventDate).tz(TIME_ZONE_NAME)) ? -1 : 1;
    });
    return sorted;
};
export const getDateModifiers = (day, today, currentDate, currentMonth, prefix) => {
    let modifiers = [];
    const dateData = dayjs(day.date).tz(TIME_ZONE_NAME);
    if (today == dateData.format(DATE_FORMAT)) {
        modifiers.push(`${prefix}today`);
    }
    if (currentDate == dateData.format(DATE_FORMAT)) {
        modifiers.push(`${prefix}active`);
    }
    if (day.events.length < 1) {
        modifiers.push(`${prefix}inactive`);
    }
    if (dayjs().startOf('day').isAfter(dateData)) {
        modifiers.push(`${prefix}past`);
    }
    if (dateData.month() !== dayjs(currentMonth).month()) {
        modifiers.push(`${prefix}outside-month`);
    }
    return modifiers.join(' ');
};
export const isInView = (element) => {
    const bounds = element.getBoundingClientRect();
    const pageHeight = window.innerHeight;
    return bounds.top < pageHeight && bounds.top > 0;
};
export const buildEmptyCalendar = (range) => {
    const { startDate, endDate } = range;
    let calendar = [];
    let allMonths = getMonthsInRange(startDate, endDate);
    allMonths.forEach(monthData => {
        monthData.days = getDaysInMonth(monthData.month);
        calendar.push(monthData);
    });
    return calendar;
};
export const insertEventsIntoCalendar = (eventList, dateRange, includeCount) => {
    const sortedEvents = sortEventsChronologically(eventList);
    const calendar = buildEmptyCalendar(dateRange);
    dayjs.extend(utc);
    dayjs.extend(timezone);
    sortedEvents.forEach(event => {
        const date = dayjs(event.eventDate).tz(TIME_ZONE_NAME);
        const month = date.startOf('month');
        const day = date.startOf('day');
        const monthGroup = calendar.filter(monthData => monthData.month == month.format(DATE_FORMAT));
        // extra null checks needed because API endpoint returns the full event list when not cached
        if (monthGroup.length > 0) {
            const dayGroup = monthGroup[0].days.filter(dayData => dayData.date == day.format(DATE_FORMAT));
            if (dayGroup.length > 0) {
                dayGroup[0].events.push(event);
            }
        }
    });
    calendar.forEach(month => {
        const daysWithEvents = month.days.filter(day => day.events.length > 0);
        const totalEvents = daysWithEvents.reduce((total, day) => { return total + day.events.length; }, 0);
        month.anyEvents = daysWithEvents.length > 0;
        if (includeCount) {
            month.eventCount = totalEvents;
        }
    });
    return calendar;
};
